// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na.page-numbers[data-v-15ffa901] {\n    color: black;\n}\na.page-numbers.current[data-v-15ffa901] {\n    color: red;\n}\na.disabled[data-v-15ffa901] {\n    pointer-events: none;\n    cursor: default;\n}\n", ""]);
// Exports
module.exports = exports;
